import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { CASE_DETAILS_STATE_KEY } from './state/data-access.state';
import { caseDetailsReducer } from './state/data-access.reducer';
import { EffectsModule } from '@ngrx/effects';
import { CaseDetailsEffects } from './state/data-access.effects';

@NgModule({
  imports: [CommonModule, StoreModule.forFeature(CASE_DETAILS_STATE_KEY, caseDetailsReducer), EffectsModule.forFeature([CaseDetailsEffects])],
  declarations: [],
  exports: [],
})
export class IntrensicCasesManagementDataAccessModule {}
